import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'

import { setSidebar } from '@app/ac'
import sendInvites from '@app/ac/send-invites'
import resetErrors from '@app/ac/reset-errors'
import { withUseModalHOC } from '@app/util/modal/use-modal-hoc'

const mapStateToProps = ({ employees, positions, loading, workspaces, workspaceId, errors }) => {
  const workspace = workspaces.find((ws) => ws.id === workspaceId)

  return {
    employees,
    positions,
    isLoading: loading.includes('send-invites') || loading.includes('load-positions'),
    workspace,
    errors: errors.filter(err => ['email-check', 'user-create', 'role-create', 'role-update'].includes(err.request))
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    sendInvites,
    resetErrors,
    setSidebar
  }, dispatch)
}

export default (component) => {
  return compose(withUseModalHOC, connect(mapStateToProps, mapDispatchToProps))(component)
}
